import React from "react";
import { useSelector } from "react-redux";

export default function Loader() {
  const { loading } = useSelector((state) => state.loading);

  return loading ? (
    <div
      className="
       fixed inset-0 
        bg-black/30 
        flex flex-col flex-wrap 
        justify-around items-center 
        text-white 
        z-[9999]
        overflow-hidden
      "
    >
      <svg
        className="loader__icon__svg"
        width="120"
        height="30"
        viewBox="0 0 120 30"
        xmlns="http://www.w3.org/2000/svg"
        fill="#07b5b5" // brand teal color
      >
        <circle cx="15" cy="15" r="15">
          <animate
            attributeName="r"
            from="15"
            to="15"
            begin="0s"
            dur="0.8s"
            values="15;9;15"
            repeatCount="indefinite"
          />
          <animate
            attributeName="fillOpacity"
            values="1;.5;1"
            dur="0.8s"
            repeatCount="indefinite"
          />
        </circle>
        <circle cx="60" cy="15" r="9" fillOpacity=".3">
          <animate
            attributeName="r"
            values="9;15;9"
            dur="0.8s"
            repeatCount="indefinite"
          />
          <animate
            attributeName="fillOpacity"
            values=".5;1;.5"
            dur="0.8s"
            repeatCount="indefinite"
          />
        </circle>
        <circle cx="105" cy="15" r="15">
          <animate
            attributeName="r"
            values="15;9;15"
            dur="0.8s"
            repeatCount="indefinite"
          />
          <animate
            attributeName="fillOpacity"
            values="1;.5;1"
            dur="0.8s"
            repeatCount="indefinite"
          />
        </circle>
      </svg>
    </div>
  ) : null;
}
